import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import * as localForage from "localforage";

import './footer.css';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [isAcceptCookies, setIsAcceptCookies] = useState('');

  const acceptCookies = () => {
    localForage.setItem('cookies', 'yes').then(function () {
      return localForage.getItem('cookies');
    }).then(function (newValue) {
      if (newValue === 'yes') {
        setIsAcceptCookies('yes');
      }
    })  
  }

  const init = () => {
    localForage.getItem('cookies').then(function (value) {
      if (value !== null) {
        if (value === 'yes') {
          setIsAcceptCookies('yes');
        }
      }
    });
  }

  useEffect(() => {
    init();
  }, []);
  
  return (<>
  <footer className="footer parker-in-action-p">
    <div className="company-image">
      <img width={205} src="https://d365pq86x330zn.cloudfront.net/66916948-61rr-4916-1668-8r1196911916.png" />
    </div>
    <nav className="footer-navbar">
      <div className="company-details">
        <p>Meet Parker a Registered Trademark of Meet Parker Ltd, a company registered in England and Wales. Company registration number: 13066663</p>
        <h4>Get Social</h4>
        <a className="icon" href="https://www.facebook.com/meetparkerai" target="_blank">
          <svg width="31" height="31" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g>
              <path fillRule="evenodd" clipRule="evenodd" d="M0 10.0558C0 15.0275 3.61083 19.1617 8.33333 20V12.7775H5.83333V10H8.33333V7.7775C8.33333 5.2775 9.94417 3.88917 12.2225 3.88917C12.9442 3.88917 13.7225 4 14.4442 4.11083V6.66667H13.1667C11.9442 6.66667 11.6667 7.2775 11.6667 8.05583V10H14.3333L13.8892 12.7775H11.6667V20C16.3892 19.1617 20 15.0283 20 10.0558C20 4.525 15.5 0 10 0C4.5 0 0 4.525 0 10.0558Z" fill="#262626"/>
            </g>
          </svg>
        </a>
        <a className="icon" href="https://www.instagram.com/meetparkerai/" target="_blank">
          <svg width="31" height="31" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.9324 5.90309C20.9206 5.06334 20.7553 4.23193 20.4437 3.44606C20.1736 2.78318 19.761 2.18117 19.2323 1.67849C18.7036 1.17581 18.0705 0.783514 17.3733 0.526666C16.5574 0.235455 15.6954 0.0779923 14.8241 0.0609825C13.7022 0.0133053 13.3466 0 10.4988 0C7.6511 0 7.2861 7.43489e-08 6.17242 0.0609825C5.3015 0.0781174 4.43993 0.235578 3.62439 0.526666C2.9271 0.783335 2.29384 1.17557 1.76512 1.67827C1.2364 2.18097 0.823871 2.78308 0.55392 3.44606C0.247026 4.22124 0.081774 5.04059 0.0653043 5.86872C0.0151599 6.93647 0 7.27464 0 9.98226C0 12.6899 -8.68848e-09 13.0358 0.0653043 14.0958C0.0827965 14.9252 0.247223 15.7434 0.55392 16.5207C0.824324 17.1835 1.23716 17.7853 1.76606 18.2878C2.29495 18.7903 2.92827 19.1824 3.62556 19.439C4.43887 19.7419 5.30058 19.9106 6.17359 19.9379C7.29659 19.9856 7.65227 20 10.5 20C13.3477 20 13.7127 20 14.8264 19.9379C15.6977 19.9216 16.5597 19.7645 17.3756 19.4733C18.0726 19.2162 18.7056 18.8238 19.2343 18.3211C19.7629 17.8185 20.1756 17.2166 20.4461 16.5539C20.7528 15.7778 20.9172 14.9595 20.9347 14.1291C20.9848 13.0624 21 12.7242 21 10.0155C20.9977 7.30791 20.9977 6.96419 20.9324 5.90309ZM10.4918 15.1026C7.5135 15.1026 5.10073 12.8085 5.10073 9.97672C5.10073 7.14492 7.5135 4.85087 10.4918 4.85087C11.9216 4.85087 13.2929 5.39091 14.3039 6.3522C15.315 7.31348 15.8829 8.61726 15.8829 9.97672C15.8829 11.3362 15.315 12.64 14.3039 13.6012C13.2929 14.5625 11.9216 15.1026 10.4918 15.1026ZM16.0975 5.85653C15.9324 5.85667 15.7688 5.82586 15.6163 5.76584C15.4637 5.70582 15.325 5.61779 15.2083 5.50677C15.0915 5.39575 14.9989 5.26393 14.9358 5.11885C14.8727 4.97377 14.8403 4.81828 14.8404 4.66127C14.8404 4.50438 14.8729 4.34903 14.9361 4.20408C14.9992 4.05913 15.0918 3.92743 15.2084 3.81649C15.3251 3.70555 15.4636 3.61755 15.6161 3.55751C15.7685 3.49747 15.9319 3.46657 16.0969 3.46657C16.2619 3.46657 16.4253 3.49747 16.5778 3.55751C16.7302 3.61755 16.8687 3.70555 16.9854 3.81649C17.1021 3.92743 17.1947 4.05913 17.2578 4.20408C17.321 4.34903 17.3535 4.50438 17.3535 4.66127C17.3535 5.3221 16.7914 5.85653 16.0975 5.85653Z" fill="#262626"/>
            <path d="M10.5 12C11.8807 12 13 10.8807 13 9.5C13 8.11929 11.8807 7 10.5 7C9.11929 7 8 8.11929 8 9.5C8 10.8807 9.11929 12 10.5 12Z" fill="#262626"/>
          </svg>
        </a>
        <a className="icon" href="https://www.linkedin.com/company/meetparker" target="_blank">
          <svg width="31" height="31" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g>
              <path d="M3.9212 0.00488281C1.76686 0.00488281 0.00366211 1.76804 0.00366211 3.92242V16.0792C0.00366211 18.2336 1.76682 19.9961 3.9212 19.9961H16.078C18.2324 19.9961 19.9949 18.2336 19.9949 16.0792V3.92242C19.9949 1.76808 18.2324 0.00488281 16.078 0.00488281H3.9212ZM4.90652 3.30384C5.93948 3.30384 6.57574 3.98196 6.59538 4.87334C6.59538 5.74504 5.93944 6.44222 4.88654 6.44222H4.86716C3.85386 6.44222 3.19892 5.74508 3.19892 4.87334C3.19892 3.98198 3.87368 3.30384 4.9065 3.30384H4.90652ZM13.8081 7.47004C15.7947 7.47004 17.2839 8.76848 17.2839 11.5588V16.7677H14.2649V11.908C14.2649 10.6868 13.8279 9.85364 12.7353 9.85364C11.9013 9.85364 11.4041 10.4152 11.1858 10.9577C11.1061 11.1518 11.0865 11.4228 11.0865 11.6943V16.7677H8.06742C8.06742 16.7677 8.10704 8.53548 8.06742 7.68308H11.0871V8.96956C11.4883 8.35056 12.2059 7.47002 13.8081 7.47002V7.47004ZM3.377 7.68374H6.39606V16.7678H3.377V7.68374Z" fill="#262626"/>
            </g>
          </svg>
        </a>
      </div>
    </nav>
  </footer>
  { !isAcceptCookies ?
  <div className="cookies">
    <div className="cookies-details">
      <h4>Cookies</h4>
      <p>This site uses cookies to offer you a better browsing experience. <Link to="/cookie-policy">Find out more how we use cookies</Link>.</p>
    </div>
    <button onClick={()=>acceptCookies()}>I accept cookies</button>
  </div>
  : null }
</>)};

export default Footer;